import api from './api.js'
import drafts from './drafts.js'
import notifications from './notifications.js'
import profileConfig from './profileConfig.js'
import statuses from './statuses.js'
import users from './users.js'

export default {
  statuses,
  notifications,
  users,
  api,
  profileConfig,
  drafts,
}
